<template>
    <div class="img-box" :style="{textAlign: layout}">
        <img class="img" v-if="url" :style="{maxHeight: maxHeight + 'px', maxWidth: '100%'}" :src="`${url}?token=${token}`"/>
    </div>
</template>

<script>
export default {
    name:'l-img',
    props:{
        url: {
            default: ''
        },
        txt:{
            type:String,
            default:'请输入描述文案'
        },
        maxHeight: {
            default: 400
        },
        layout: {
            default: 'center'
        },
    },
    wath: {
       url () {
        this.$forceUpdate()
       }
    },
    computed: {
        styleObj () {
            let obj = {}
            if (this.css) {
                try {
                   obj = JSON.parse(this.css) 
                } catch (error) {
                    
                }
            }
            return obj
        }
    }
}
</script>